<body id="rt_body">
  <div class="container">
    <div class="row">
      <div class="col-12 col-md-8 col-lg-6 col-xl-5 mx-auto">
        <div class="bhakts-container rt-signup">
          <div class="card login-form">
            <div class="card-body">
              <h3 class="card-title text-center">BHAKTS SIGNUP</h3>
              <div class="card-text login-form1">
                @if (isInvalid) {
                  <div class="alert alert-danger alert-dismissible fade show" role="alert">
                  {{errMessage}}</div>
                }
                <form class="admin-form" (ngSubmit)="adminRegister()">
                  <div class="user-form">
                    <div class="form-group">
                      <label for="firstName">First Name</label>
                      <input type="text" class="form-control form-control-sm" id="firstName" name="firstName"
                        [(ngModel)]="firstName" required>
                    </div>
                  </div>
                  <div class="user-form">
                    <div class="form-group">
                      <label for="lastName">Last Name</label>
                      <input type="text" class="form-control form-control-sm" id="lastName"name="username"
                        [(ngModel)]="lastName" required>
                    </div>
                  </div>
                  <div class="user-form">
                    <div class="form-group">
                      <label for="InputEmail">Email</label>
                      <input type="email" class="form-control form-control-sm" id="InputEmail"
                        aria-describedby="emailHelp" name="email" [(ngModel)]="email" required>
                    </div>
                  </div>
                  <div class="user-form">
                    <div class="form-group">
                      <label for="InputPhone">Phone</label>
                      <input type="tel" class="form-control form-control-sm" id="InputPhone"
                        aria-describedby="emailHelp" name="phone" [(ngModel)]="phone" required>
                    </div>
                  </div>
                  <div class="user-form">
                    <div class="form-group">
                      <label for="exampleInputPassword1">Password</label>
                      <input type="password" class="form-control form-control-sm" id="exampleInputPassword1"
                        [(ngModel)]="password" name="password" required>
                    </div>
                  </div>

                  <button type="submit" class="btn btn-primary btn-block"><a href="#">Sign Up</a></button>

                  <div class="sign-up">
                    Already have an account? <a routerLink='/login'>Sign In</a>
                  </div>
                  <router-outlet></router-outlet>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
